module.exports = __webpack_public_path__ + "static/media/ic-2.cc66762c.svg";